// Image imports
import alexanderLobanovPortrait from '../../../images/alexander-lobanov.jpg';

export const alexanderLobanovMemorial = {
  id: 15,
  name: 'Alexander Lobanov',
  category: 'young-lives',
  images: {
    portrait: alexanderLobanovPortrait
  },
  info: `

"He helped others escape while he himself was captured." - Friend of Alexander

# Alexander Lobanov

![Alexander Lobanov](${alexanderLobanovPortrait})
*Alexander Lobanov, father and protector until the end*

## A Father Above All

Alexander Lobanov was 32 years old, a resident of the southern coastal city of Ashkelon and a devoted father to two young children - including a baby born during his captivity who he would never meet. On October 7th, 2023, Alexander was working as a bar manager at the Nova music festival when Hamas terrorists attacked.

According to witnesses, in the chaos of gunfire and panic, Alexander helped others escape, guiding them to safety before fleeing with a group to the nearby Be'eri forest. It was there that he was captured by militants and taken to Gaza.

## Dreams Interrupted

Alexander had so many plans for his growing family. His older child was just two years old, and his wife was pregnant with their second child when he was taken hostage. He had been saving to buy a home where his children could have a yard to play in. Friends described him as a man who worked hard not for himself, but for the future he was building for his family.

Those who knew Alexander spoke of his generosity and kindness. As a bar manager, he had a talent for making people feel welcome, remembering regulars' favorite drinks, and turning strangers into friends. His warm smile and quick wit made him beloved by both colleagues and customers.

## A Child He Never Met

In the months after his abduction, Alexander's wife gave birth to their second child. The baby, who should have known a father's embrace, instead became a symbol of the cruelty of his absence. The newborn's arrival was bittersweet - a new life beginning while Alexander's hung in the balance.

Family and friends gathered to support Alexander's wife and children, stepping in to help where they could, but always aware that no one could fill the void left by the missing father.

## A Final Tragedy

On August 31, 2024, after nearly 11 months in captivity, Alexander's body was recovered from a tunnel in Rafah along with five other hostages. Israeli officials reported that all six had been executed by their captors shortly before they were found.

At his funeral, Alexander's two children were present - the older one confused and distressed, the baby too young to understand the gravity of the moment. His wife, holding both children, embodied strength in the face of unbearable pain.

## Legacy of Love

Though Alexander's children will grow up without their father's physical presence, they will be raised knowing the truth of who he was - a man who helped others even at risk to himself, who loved his family above all else, and whose final act was one of courage.

A memorial fund has been established in Alexander's name to support his children's education and future, ensuring that though their father was taken from them, his dreams for their lives can still be realized.

May his memory be a blessing, and may his children find comfort in knowing the hero their father was.

`
};